<template>
  <div>
    <v-layout mb-3 justify-center class="subheading text--darken-1 text-xs-center" :class="colorClass"><slot></slot></v-layout>
  </div>
</template>

<script>
export default {
  name: 'o-base-center-text',
  props: {
    colorClass: {
      type: String,
      default: 'grey--text'
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/generic/textos/OBaseCenterText.vue